import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render() {
  var _vm$title, _vm$btnAdditionals;
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    style: {
      zIndex: _vm.styleOptions.zIndex
    },
    attrs: {
      persistent: "",
      width: _vm.styleOptions.width,
      "max-width": _vm.styleOptions.maxWidth
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [_vm.dialogOptions.showTitle ? _c(VToolbar, {
    attrs: {
      color: _vm.styleOptions.color,
      dense: "",
      flat: ""
    }
  }, [_c(VToolbarTitle, {
    staticClass: "dialog-title"
  }, [_vm._v(" " + _vm._s((_vm$title = _vm.title) !== null && _vm$title !== void 0 ? _vm$title : "Unexpected error occurred") + " ")])], 1) : _vm._e(), _c(VCardText, [_c("div", {
    staticClass: "pt-4 mb-3"
  }, [_vm.dialogType == _vm.ERROR_DATA.DIALOG_TYPES.DIALOG_RELOAD.id && !_vm.dialogOptions.hideDefaultMessage ? [_vm._v(" We are encountering an unexpected error. "), _c("br"), _vm._v(" The page will reload and you should be able to continue browsing under normal conditions. "), _c("br"), _vm._v(" We apologize for any inconvenience. ")] : _vm._e()], 2), _vm.dialogOptions.showMessage && _vm.message && !_vm.isMessageDefault ? _c("div", {
    staticClass: "mb-3"
  }, [!_vm.styleOptions.isHtmlMessage ? [_vm._v(_vm._s(_vm.message))] : _vm._e(), _vm.styleOptions.isHtmlMessage ? [_c("div", {
    domProps: {
      innerHTML: _vm._s(String.nl2br(_vm.message))
    }
  })] : _vm._e()], 2) : _vm._e(), _vm.dialogType == _vm.ERROR_DATA.DIALOG_TYPES.DIALOG_RELOAD.id && !_vm.dialogOptions.hideDefaultFooterMessage ? _c("div", [_vm._v(" If the problem persists, please let us know on our contact page, or explain the context of this issue via email to your contact at Clos&Monopole. "), _c("br"), _vm._v(" You can try signing out and then signing back in; this might resolve the issue. "), _c("br"), _vm._v(" Thank you for your understanding. ")]) : _vm._e()]), _c(VCardActions, [((_vm$btnAdditionals = _vm.btnAdditionals) === null || _vm$btnAdditionals === void 0 ? void 0 : _vm$btnAdditionals.length) > 0 ? _vm._l(_vm.btnAdditionals, function (btnAdditional, index) {
    var _btnAdditional$iconCl, _btnAdditional$text;
    return _c(VBtn, {
      key: "dialog-btn-additional-" + index,
      staticClass: "dfwa-btn --small",
      attrs: {
        rounded: "",
        to: btnAdditional.to
      }
    }, [((_btnAdditional$iconCl = btnAdditional.iconClass) === null || _btnAdditional$iconCl === void 0 ? void 0 : _btnAdditional$iconCl.length) > 0 ? _c(VIcon, {
      class: [btnAdditional.iconClass, "mr-2"],
      attrs: {
        size: "0.75rem"
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(((_btnAdditional$text = btnAdditional.text) === null || _btnAdditional$text === void 0 ? void 0 : _btnAdditional$text.length) > 0 ? btnAdditional.text : "Action") + " ")], 1);
  }) : _vm._e(), _vm.dialogType == _vm.ERROR_DATA.DIALOG_TYPES.DIALOG_RELOAD.id ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.reloadPage
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-redo-alt mr-2",
    attrs: {
      size: "0.75rem"
    }
  }), _vm._v(" Reload page ")], 1) : _vm.dialogType == _vm.ERROR_DATA.DIALOG_TYPES.DIALOG_WARNING.id ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click() {
        _vm.dialog = false;
      }
    }
  }, [_vm._v(" Close ")]) : _vm._e()], 2)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };